import { Container } from '@dma/ui';
import { contactInfoContent } from '../content/company-info.content';
import './Footer.css';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="dma-footer">
      <Container>
        <div className="dma-footer__grid">
          <div>
            <img src="/images/logo.jpg" alt={contactInfoContent.companyName} className="dma-footer__logo" />
            <p className="dma-footer__brand">{contactInfoContent.companyName}</p>
            <p className="dma-footer__address">{contactInfoContent.address}</p>
          </div>
          <div className="dma-footer__contact">
            <a href={`tel:${contactInfoContent.phone}`}>{contactInfoContent.phone}</a>
            <a href={`mailto:${contactInfoContent.email}`}>{contactInfoContent.email}</a>
            <a href={contactInfoContent.whatsappHref} target="_blank" rel="noreferrer">
              واتساپ
            </a>
          </div>
        </div>
        <p className="dma-footer__text">
          © {currentYear} {contactInfoContent.companyName}
        </p>
      </Container>
    </footer>
  );
}
